export default __webpack_public_path__ + "static/media/image3.98390b45.png";